export const COMPULSORY_SUBJECTS_TYPE_ID = 101;
export const MIN_COUNT_SEARCH_SYMBOLS = 3;